import Vue from 'vue'
import VueFirebaseAnalytics, { fa } from '@/plugins/FirebaseAnalytics'
import router from '@/router'

export default () => {
  const isProd = process.env.NODE_ENV === 'production'

  return {
    init: () => {
      Vue.use(VueFirebaseAnalytics, {
        vueAnalytics: {
          id: 'UA-89481759-2',
          debug: {
            enabled: !isProd,
            sendHitTask: isProd
          },
          router
        },
        deactivated: process.env.E2E
      })
    },
    setUser: (user) => {
      fa.setUserId(user ? user.uid : null)
    }
  }
}
